export default __webpack_public_path__ + "static/media/Cunia.f7d85144.otf";